/**
 * @fileoverview added by tsickle
 * Generated from: lib/masking-base/masking-base.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class MaskingBase {
    constructor() {
        this._mask = "";
        this._slotChar = "_";
        this._showPlaceholder = false;
        this._overwriteOnInsert = false;
    }
    /**
     * @private
     * @param {?} s
     * @return {?}
     */
    static isNumeric(s) {
        if (s === " ") {
            return false;
        }
        return !isNaN(Number(s));
    }
    /**
     * @private
     * @param {?} s
     * @return {?}
     */
    static isAlpha(s) {
        return s.match(/^[a-z]+$/i) !== null;
    }
    /**
     * @param {?=} onFocus
     * @return {?}
     */
    checkValue(onFocus = false) {
        this.oldValue = this.value;
        this.value = this._input.value;
        this.focus = onFocus;
        if (!this.focus && this.oldValue.length < this._input.value.length && !this.isInputKeyAcceptable()) {
            this.caretPos = this._input.selectionStart;
            this.value = this.oldValue;
            this._input.value = this.oldValue;
            this._input.selectionStart = this.caretPos - 1;
            this._input.selectionEnd = this.caretPos - 1;
            return;
        }
        if (this._overwriteOnInsert && this._input.selectionStart < this._input.value.length && !this.focus) {
            /** @type {?} */
            let selectionStart = this._input.selectionStart;
            if (!MaskingBase.isAlpha(this.value.charAt(selectionStart)) && !MaskingBase.isNumeric(this.value.charAt(selectionStart))) {
                selectionStart++;
            }
            this.value = this.value.slice(0, selectionStart) + this.value.slice(selectionStart + 1);
        }
        if (!this.value && !this.focus) {
            return;
        }
        this.maskValue();
    }
    /**
     * @private
     * @return {?}
     */
    isInputKeyAcceptable() {
        if (this._mask.charAt(this._input.selectionStart - 1) === "9"
            && !MaskingBase.isNumeric(this._input.value.charAt(this._input.selectionStart - 1))) {
            return false;
        }
        if (this._mask.charAt(this._input.selectionStart - 1) === "A"
            && !MaskingBase.isAlpha(this._input.value.charAt(this._input.selectionStart - 1))) {
            return false;
        }
        if (this.getConstChars().includes(this._mask.charAt(this._input.selectionStart - 1))) {
            if (this._mask.charAt(this._input.selectionStart) === "9"
                && !MaskingBase.isNumeric(this._input.value.charAt(this._input.selectionStart - 1))) {
                return false;
            }
            if (this._mask.charAt(this._input.selectionStart) === "A"
                && !MaskingBase.isAlpha(this._input.value.charAt(this._input.selectionStart - 1))) {
                return false;
            }
        }
        return true;
    }
    /**
     * @private
     * @return {?}
     */
    getConstChars() {
        /** @type {?} */
        const constChars = this._mask.replace(/[9A]/g, "").split("");
        return constChars.filter((/**
         * @param {?} v
         * @param {?} i
         * @param {?} a
         * @return {?}
         */
        (v, i, a) => a.indexOf(v) === i));
    }
    /**
     * @return {?}
     */
    maskValue() {
        /** @type {?} */
        let maskedValue = "";
        /** @type {?} */
        let dif = 0;
        /** @type {?} */
        let foundPlaceholder = false;
        this.value = this.removeMask(this.value);
        for (let i = 0; i < this._mask.length && this.value.length !== i; i++) {
            /** @type {?} */
            const maskChar = this._mask.charAt(i + dif);
            /** @type {?} */
            const valueChar = this.value.charAt(i);
            if (this._showPlaceholder && valueChar === this._slotChar) {
                if (foundPlaceholder) {
                    break;
                }
                foundPlaceholder = true;
            }
            if (!MaskingBase.isAlpha(valueChar)
                && !MaskingBase.isNumeric(valueChar)
                && valueChar !== maskChar) {
                this.value = this.value.substring(0, i) + this.value.substring(i + 1);
                i--;
            }
            else if (maskChar === "9") {
                if (MaskingBase.isNumeric(valueChar)) {
                    maskedValue += valueChar;
                }
                else {
                    this.value = this.value.substring(0, i) + this.value.substring(i + 1);
                    i--;
                }
            }
            else if (maskChar === "A") {
                if (MaskingBase.isAlpha(this.value.charAt(i))) {
                    maskedValue += valueChar;
                }
                else {
                    this.value = this.value.substring(0, i) + this.value.substring(i + 1);
                    i--;
                }
            }
            else if (maskChar !== valueChar && maskedValue.charAt(i + dif) !== maskChar) {
                maskedValue += maskChar;
                dif++;
                i--;
            }
            else {
                maskedValue += maskChar;
            }
        }
        this.oldLength = maskedValue.length;
        if (this._showPlaceholder) {
            maskedValue = this.fillWithPlaceholder(maskedValue);
            this.oldValue = this.fillWithPlaceholder(this.oldValue, true);
        }
        this.caretPos = this.getUpdatedCaretPos(maskedValue);
        this.value = maskedValue;
        this.updateInput();
    }
    /**
     * @param {?} value
     * @return {?}
     */
    removeMask(value) {
        /** @type {?} */
        let finalValue = value;
        /** @type {?} */
        const constChars = this.getConstChars();
        /** @type {?} */
        const regexpSlotChar = new RegExp(this._slotChar, "g");
        finalValue = finalValue.replace(regexpSlotChar, "");
        for (let constCharsKey of constChars) {
            constCharsKey = "\\" + constCharsKey;
            /** @type {?} */
            const regExp = new RegExp(constCharsKey, "g");
            finalValue = finalValue.replace(regExp, "");
        }
        return finalValue;
    }
    /**
     * @return {?}
     */
    updateInput() {
        this._input.value = this.value;
        if (this.focus && this.clear) {
            this.caretPos = 0;
            setTimeout((/**
             * @return {?}
             */
            () => {
                this._input.selectionStart = this.caretPos;
                this._input.selectionEnd = this.caretPos;
            }), 0);
        }
        else {
            this._input.selectionStart = this.caretPos;
            this._input.selectionEnd = this.caretPos;
        }
    }
    /**
     * @private
     * @param {?} maskedValue
     * @return {?}
     */
    getUpdatedCaretPos(maskedValue) {
        /** @type {?} */
        let caretPos = this.getCaretPos();
        /** @type {?} */
        const startCaretPos = caretPos;
        if (caretPos === this._input.value.length || caretPos === this.oldLength) {
            caretPos = this.oldLength;
        }
        else {
            while (caretPos < this.value.length &&
                this._mask.charAt(caretPos) !== "9" &&
                this._mask.charAt(caretPos) !== "A") {
                caretPos++;
            }
        }
        if (this._mask.charAt(caretPos - 1) !== "9" && this._mask.charAt(caretPos - 1) !== "A" && caretPos === startCaretPos) {
            caretPos++;
        }
        return caretPos;
    }
    /**
     * @private
     * @param {?} value
     * @param {?=} oldValue
     * @return {?}
     */
    fillWithPlaceholder(value, oldValue = false) {
        if (value === undefined || value === null) {
            return value;
        }
        if (!oldValue && this.focus) {
            this.clear = !value || value.length === 0;
        }
        /** @type {?} */
        let mask = this._mask.replace(/[9A]/g, this._slotChar);
        mask = mask.substring(value.length, mask.length);
        value = value + mask;
        return value;
    }
    /**
     * @return {?}
     */
    blurEvent() {
        if (this.value.indexOf(this._slotChar) !== -1) {
            this.value = "";
            this.updateInput();
        }
    }
    /**
     * @return {?}
     */
    getCaretPos() {
        return this._input.selectionStart;
    }
}

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: racoon-mask-base.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { MaskingBase };

//# sourceMappingURL=racoon-mask-base.js.map